<template>
    <div class="px-4 py-8 sm:px-6 md:py-12 lg:px-16 bg-[#00395A0D]">
        <h2 class="text-3xl sm:text-[40px] font-[900] mb-6 capitalize text-left">Circulars</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            <a v-for="(item, index) in sortedCirculars"
               :key="index"
               :href="item.linkMedia"
               target="_blank" 
               rel="noopener noreferrer"
               class="block bg-white p-4 sm:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ease-in-out group flex flex-col">
                
                <h3 class="text-base sm:text-lg font-semibold text-[#00395a] group-hover:underline mb-3 leading-tight">
                    {{ item.linkTitle }}
                </h3>
                <p class="text-base text-gray-700 mb-4 flex-grow">
                    {{ truncateText(item.linkName, 100) }}
                </p>
                <div class="mt-auto">
                    <span class="text-sm font-medium text-[#00395a] group-hover:underline">
                        Read More 
                        <span aria-hidden="true" class="ml-1 transition-transform duration-300 group-hover:translate-x-1">&rarr;</span>
                    </span>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
export default {
  name: 'HomeCirculars',
  props: {
    circularItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // Additional data properties can be added here if needed
      //  circularItems: [
      //       {
      //           title: 'Medical Camp',
      //           link: '/events/annual-general-meeting',
      //           date: '2025-05-15',
      //           description: 'Join us for our Annual General Meeting to discuss the year\'s achievements and future plans.'

      //       },
      //       {
      //           title: 'Cultural Festival',
      //           link: '/events/cultural-festival',
      //           image: './../../assets/events/cultural-festival.jpg',
      //           date: '2025-06-20',
      //           description: 'Experience the rich cultural heritage of our community at the annual Cultural Festival.'
      //       },
      //       {
      //           title: 'Charity Run',
      //           link: '/events/charity-run',
      //           image: './../../assets/events/charity-run.jpg',
      //           date: '2025-07-10',
      //           description: 'Participate in our Charity Run to support local causes and promote health and fitness. '
      //       },
      //       {
      //           title: 'Community Service Day',
      //           link: '/events/community-service-day',
      //           image: './../../assets/events/community-service-day.jpg',
      //           date: '2025-08-05',
      //           description: 'Join us for a day of community service to give back and make a difference in our neighborhood.'
      //       }
      //   ]
    };
  },
  computed: {
    sortedCirculars() {
      if (!this.circularItems) {
        return [];
      }
      // Sort by date in descending order (newest first)
      // To sort in ascending order (oldest first), swap b and a.
      return [...this.circularItems].sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  },
  // data() { // If you still need local data for other purposes, it can remain.
  //   return {};
  // },
  methods: {
    getFormattedDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },
    truncateText(text, maxLength) {
      if (!text || text.length === 0) return '';
      if (text.length <= maxLength) {
        return text;
      }
      // Attempt to truncate at the last space within maxLength
      const part = text.substr(0, maxLength);
      const lastSpace = part.lastIndexOf(" ");
      if (lastSpace > 0 && lastSpace < maxLength - 3) { // Ensure space is not too close to end
        return part.substr(0, lastSpace) + '...';
      }
      // If no suitable space, or text is short, truncate directly
      return text.substr(0, maxLength - 3) + '...';
    }
  }
};
</script>